import unionBy from 'lodash/unionBy';

/**
 * Merges two arrays into one, removing duplicate objects based on a specified identifier.
 *
 * @param arr1 - The first array to merge.
 * @param arr2 - The second array to merge.
 * @param identifier - The key used to determine uniqueness of objects in the arrays.
 * @returns A new array containing the union of both input arrays, with duplicates removed.
 */

export function unionArray<T>(arr1: T[], arr2: T[], identifier: keyof T): T[] {
  const array = [...arr1, ...arr2];

  return unionBy(array, identifier);
}
